import Swiper from 'swiper/dist/js/swiper';
import lightGallery from 'lightgallery/dist/js/lightgallery-all';
import Form from "../form";

let Barba = require('barba.js');

module.exports = Barba.BaseView.extend({
    namespace: 'rent-page',

    onEnterCompleted: function () {
        let form = new Form('#rent-form', {}, {
            url: '/ajax/rent-form'
        });

        let videoLink = document.querySelector('.video__content').getAttribute('data-video-link');
        let idVideoLink = getYoutubeVideoID(videoLink);
        let iframe = document.querySelector('.video__content');
        iframe.src = "https://www.youtube.com/embed/" + idVideoLink;

        new Swiper('.swiper-container', {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 3,
            spaceBetween: 15,
            navigation: {
                nextEl: '.about__gallery-arrow_right',
                prevEl: '.about__gallery-arrow_left',
            },
            breakpoints: {
                767: {
                    slidesPerView: 1,
                    spaceBetween: 30
                }
            }
        });

        $('#lightgallery').lightGallery({
            thumbnail: false,
            fullScreen: false,
            autoplay: false,
            autoplayControls: false,
            counter: false,
            download: false,
            zoom: false,
            share: false,
        });

        function getYoutubeVideoID(url) {
            let youtube_id = '';
            if (url.includes("youtube.com")) {
                let params = new URLSearchParams(new URL(url).search);
                youtube_id = params.get('v');
            } else if (url.includes("youtu.be")) {
                let urlParts = url.split("/");
                youtube_id = urlParts[urlParts.length - 1];
            }
            if (youtube_id) {
                return youtube_id;
            }
        }
    },

    onLeave: function () {

    }
});



// WEBPACK FOOTER //
// resources/assets/src/js/views/rent-page.js